/** @jsxImportSource @emotion/react */
import { Box, useTheme } from '@mui/material'
import { bannerBlock, bannerContent, innerBannerColumn } from './Banner.styles'

export type BannerBlockProps = {
  header?: string // warning
  subheader?: string // warning
  backgroundImageUrl?: string
  heroImageUrl?: string
  heroImageAlt?: string
}
/**
 * Banner component displays a header, optional subheader, and an optional hero image.
 *
 * @param header - Main heading text.
 * @param subheader - Optional subheading text.
 * @param heroImageUrl - If provided, expands the banner significantly and displays the image on the right side.
 * @param heroImageAlt - Alt text for the hero image.
 * @returns React component rendering the banner.
 */
export const Banner = ({ header, subheader, heroImageUrl, heroImageAlt }: BannerBlockProps) => {
  const theme = useTheme()

  return (
    <Box css={bannerBlock({ theme, expanded: !!heroImageUrl })}>
      <Box css={bannerContent}>
        <Box>
          <Box css={innerBannerColumn}>
            <h1>{header}</h1>
            {subheader && <p>{subheader}</p>}
          </Box>
          {heroImageUrl && (
            <Box css={innerBannerColumn} style={{ minWidth: '54%' }}>
              <Box component="img" src={heroImageUrl} alt={heroImageAlt} />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  )
}
